/* GoClove PLP — Mobile Quick Add: bottom sheet, sex toggle, size chart, CTA */
(function () {
  if (window.__GOC_PLP_MOBILE_QA__) return;
  window.__GOC_PLP_MOBILE_QA__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;
  const LABELS = window.__GOC_LABELS__ || {};

  const QA = {
    inited: false, el: null, activeCard: null, openToken: 0, aborter: null,
    state: {
      sex: "womens",
      productsBySex: { womens: [], mens: [] },
      activeIndexBySex: { womens: 0, mens: 0 },
      selectedVariantId: null, selectedPrice: null,
      sexSwitchToken: 0, baseKeys: [],
      // Determined once at modal open from the source card. Sticky for the
      // whole session so a color change or sex switch can't flip the toggle
      // off mid-flow because an individual item happened to lack hydrated
      // variants or had unusual product_type data.
      isFootwearSession: false
    }
  };

  const SEX_INDEX = { loaded: false, loading: null, map: new Map(), byRoot: new Map() };
  const PROD = { index: 0 };
  const SIZE = { idx: 0 };
  const SIZE_DRAG = { active: false, startX: 0, startOffset: 0, moved: 0, maxOffset: 0, chipStep: 1, pointerId: null, targetChip: null };
  const SC = { el: null, inited: false };
  window.__GOC_SC_CACHE__ = window.__GOC_SC_CACHE__ || new Map();

  // ---- Tag helpers ----
  function normColor(s) { return String(s || "").toLowerCase().replace(/\s+/g, " ").trim(); }

  function styleFromTags(tagsInput) {
    const { parseTagsAny } = GOC;
    const t = parseTagsAny(tagsInput).map(x => String(x).toLowerCase());
    const exceptions = LABELS.styleExceptions || [];
    for (const ex of exceptions) { if (t.includes(ex.toLowerCase())) return ex.toLowerCase(); }
    const prefix = (LABELS.styleTagPrefix || "").toLowerCase();
    if (prefix) { for (const tag of t) { if (tag.startsWith(prefix)) return tag.slice(prefix.length).trim().replace(/\s+/g, "-"); } }
    return LABELS.defaultStyle || "";
  }

  function colorFromTitle(title) {
    const t = String(title || ""); const parts = t.split(" - ");
    return parts.length > 1 ? parts.slice(1).join(" - ").trim() : t.trim();
  }

  function tagsMatchGender(tags, gender) {
    const gt = LABELS.genderTags || { mens: [], womens: [] };
    const patterns = gt[gender] || [];
    const lower = tags.map(x => String(x).toLowerCase());
    return patterns.some(p => lower.includes(p.toLowerCase()));
  }

  // Gender-pair handle helpers. Product handles follow the
  // `clove-{style}-{womens|mens}-{color}` convention, so the opposite-sex handle
  // is a straight token swap (mirrors snippets/goc-product-card-swatch.liquid).
  function genderedHandleFromHandle(handle, sexKey) {
    const h = String(handle || "");
    if (!h) return "";
    if (sexKey === "mens") {
      if (h.indexOf("-womens-") !== -1) return h.replace("-womens-", "-mens-");
      return h;
    }
    if (h.indexOf("-mens-") !== -1) return h.replace("-mens-", "-womens-");
    return h;
  }
  // Gender-stripped handle, used to pair the two sexes in SEX_INDEX regardless of
  // how their titles/subtitles read (so the Toy Story products, whose swatch
  // subtitle "Buzz" differs from the title-derived color, still pair correctly).
  function handleRoot(handle) { return String(handle || "").toLowerCase().replace(/-mens-|-womens-/, "-x-"); }

  function sexFromTags(tagsInput) {
    const { parseTagsAny } = GOC;
    const t = parseTagsAny(tagsInput);
    if (tagsMatchGender(t, "mens")) return "mens";
    if (tagsMatchGender(t, "womens")) return "womens";
    return null;
  }

  function upsertItemIntoSexLists(item) {
    const sex = sexFromTags(item.tags) || "womens";
    ["womens", "mens"].forEach(sx => {
      const list = QA.state.productsBySex[sx] || [];
      const idx = list.findIndex(x => x && x.handle === item.handle);
      if (idx >= 0) Object.assign(list[idx], item);
      else if (sx === sex) list.push(item);
      QA.state.productsBySex[sx] = list;
    });
  }

  // ---- SEX_INDEX loading ----
  async function loadSexIndexOnce() {
    if (SEX_INDEX.loaded) return true;
    if (SEX_INDEX.loading) return SEX_INDEX.loading;
    const { parseTagsAny } = GOC;

    SEX_INDEX.loading = (async () => {
      try {
        let page = 1, safety = 0;
        while (safety < 40) {
          safety += 1;
          const r = await fetch(`/collections/all/products.json?limit=250&page=${page}`, { headers: { "Accept": "application/json" } });
          if (!r.ok) break;
          const data = await r.json();
          const products = Array.isArray(data?.products) ? data.products : [];
          if (!products.length) break;
          for (const p of products) {
            const tags = parseTagsAny(p?.tags);
            const sex = sexFromTags(tags);
            if (!sex) continue;
            const style = styleFromTags(tags);
            const color = normColor(colorFromTitle(p?.title));
            const key = `${style}|${color}`;
            if (!SEX_INDEX.map.has(key)) SEX_INDEX.map.set(key, { womens: null, mens: null });
            const slot = SEX_INDEX.map.get(key);
            if (sex === "mens") slot.mens = p.handle; else slot.womens = p.handle;
            const root = handleRoot(p.handle);
            if (!SEX_INDEX.byRoot.has(root)) SEX_INDEX.byRoot.set(root, { womens: null, mens: null });
            const slotR = SEX_INDEX.byRoot.get(root);
            if (sex === "mens") slotR.mens = p.handle; else slotR.womens = p.handle;
          }
          page += 1;
        }
        SEX_INDEX.loaded = true;
        return true;
      } catch (e) { return false; }
    })();
    return SEX_INDEX.loading;
  }

  // ---- Variant helpers ----
  function normalizeVariantOptionsFromProductJs(variant) {
    const out = [];
    if (variant?.option1 != null) out.push(String(variant.option1));
    if (variant?.option2 != null) out.push(String(variant.option2));
    if (variant?.option3 != null) out.push(String(variant.option3));
    return out;
  }

  function inferSizeIndexFromProductJs(product) {
    const names = Array.isArray(product?.options) ? product.options.map(x => String(x || "")) : [];
    let idx = names.map(n => n.toLowerCase()).findIndex(n => n.includes("size"));
    if (idx >= 0) return idx;
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    if (!variants.length) return 0;
    const score = [0, 0, 0];
    const isSizeLike = (v) => /^[0-9]{1,2}(\.[0-9]{1,2})?$/.test(String(v || "").trim());
    for (const v of variants) {
      const opts = normalizeVariantOptionsFromProductJs(v);
      for (let i = 0; i < Math.min(opts.length, 3); i++) if (isSizeLike(opts[i])) score[i] += 1;
    }
    let best = 0;
    for (let i = 1; i < score.length; i++) if (score[i] > score[best]) best = i;
    return best;
  }

  function parseMoreHandles(card) {
    const moreEl = card.querySelector(".gpcard__more[data-more-handles]");
    if (!moreEl) return [];
    const raw = moreEl.getAttribute("data-more-handles") || "";
    if (!raw) return [];
    try { const parsed = JSON.parse(raw); return Array.isArray(parsed) ? parsed : []; }
    catch (e) { return raw.split(/[\s,|]+/).map(s => s.trim()).filter(Boolean); }
  }

  function getActiveSwatchIndexInDom(card) {
    const sw = Array.from(card.querySelectorAll('.gpcard__swatch[data-sp-handle]'));
    if (!sw.length) return 0;
    let idx = sw.findIndex(b => b.classList.contains('is-active'));
    return idx < 0 ? 0 : idx;
  }

  // ---- Size chart modal ----
  function ensureSizeChartModalOnce() {
    if (SC.inited && SC.el && document.body.contains(SC.el)) return;
    SC.inited = true;
    const el = document.createElement("div");
    el.className = "gocsc"; el.setAttribute("aria-hidden", "true");
    el.innerHTML = `<div class="gocsc__backdrop" data-gocsc-close></div>
      <div class="gocsc__panel" role="dialog" aria-modal="true" aria-label="Size chart">
        <div class="gocsc__body">
          <button class="gocsc__close" type="button" aria-label="Close" data-gocsc-close>×</button>
          <div class="gocsc__content" data-gocsc-body><div class="gocsc__loading" style="font-size:12px;color:#6b7280">${LABELS.loading}</div></div>
        </div>
      </div>`;
    document.body.appendChild(el); SC.el = el;
    el.addEventListener("click", (e) => { if (e.target.closest("[data-gocsc-close]")) { e.preventDefault(); closeSizeChartModal(); } });
    document.addEventListener("keydown", (e) => { if (SC.el && SC.el.getAttribute("aria-hidden") === "false" && e.key === "Escape") closeSizeChartModal(); });
  }

  function openSizeChartModal() { ensureSizeChartModalOnce(); SC.el.setAttribute("aria-hidden", "false"); }
  function closeSizeChartModal() { if (SC.el) SC.el.setAttribute("aria-hidden", "true"); }

  function extractSizeChartHtml(raw) {
    const trimmed = (raw || "").trim();
    if (!trimmed) return "";
    // If the response is a full HTML document (e.g. the size-chart-legacy template
    // wasn't found and Shopify served the standard PDP), pull out only the body
    // content and strip layout-bound elements so we don't blow up the modal.
    if (/<html[\s>]|<!doctype/i.test(trimmed)) {
      try {
        const doc = new DOMParser().parseFromString(trimmed, "text/html");
        doc.querySelectorAll("script, link, style, meta, noscript, iframe, header, footer, nav").forEach((n) => n.remove());
        const tables = doc.querySelectorAll("table");
        if (tables.length) {
          const wrap = document.createElement("div");
          tables.forEach((t) => wrap.appendChild(t.cloneNode(true)));
          return wrap.innerHTML.trim();
        }
        return (doc.body && doc.body.innerHTML || "").trim();
      } catch (_) { /* fall through and use raw */ }
    }
    // Snippet response ({% layout none %}): keep only the size tables, dropping
    // h3 headings, recommendation paragraphs and any other surrounding markup so
    // the popup shows a clean chart.
    try {
      const doc = new DOMParser().parseFromString(trimmed, "text/html");
      const tables = doc.querySelectorAll("table");
      if (tables.length) {
        const wrap = document.createElement("div");
        tables.forEach((t) => wrap.appendChild(t.cloneNode(true)));
        return wrap.innerHTML.trim();
      }
    } catch (_) { /* fall through and use raw */ }
    return trimmed;
  }

  async function openSizeChartForHandle(handle) {
    if (!handle) return;
    ensureSizeChartModalOnce();
    const body = SC.el.querySelector("[data-gocsc-body]");
    if (!body) return;
    openSizeChartModal();
    const cache = window.__GOC_SC_CACHE__;
    if (cache.has(handle)) { body.innerHTML = cache.get(handle); return; }
    body.innerHTML = `<div style="font-size:12px;color:#6b7280">${LABELS.loading}</div>`;
    try {
      const scView = LABELS.sizeChartView || "size-chart";
      const r = await fetch(`/products/${handle}?view=${scView}`, { headers: { "Accept": "text/html" } });
      if (!r.ok) throw new Error("fail");
      const raw = await r.text();
      const extracted = extractSizeChartHtml(raw);
      const cleaned = extracted || `<div style="font-size:12px;color:#6b7280">${LABELS.noSizeChart}</div>`;
      cache.set(handle, cleaned); body.innerHTML = cleaned;
    } catch (e) { body.innerHTML = `<div style="font-size:12px;color:#6b7280">${LABELS.sizeChartError}</div>`; }
  }

  function openSizeChart() { const it = getActiveItem(); if (it?.handle) openSizeChartForHandle(it.handle); }

  // ---- Hydration ----
  async function fetchMoreProductsIntoPopup(handles, token, signal) {
    if (token !== QA.openToken) return;
    const { parseTagsAny } = GOC;
    window.__GOC_QA_CACHE__ = window.__GOC_QA_CACHE__ || new Map();
    const cache = window.__GOC_QA_CACHE__;
    const existing = new Set(([]).concat(QA.state.productsBySex.womens || [], QA.state.productsBySex.mens || []).map(i => i.handle).filter(Boolean));
    const toFetch = handles.filter(h => h && !existing.has(h));
    if (!toFetch.length) return;
    const results = [];
    for (let i = 0; i < toFetch.length; i += 6) {
      if (signal?.aborted || token !== QA.openToken) return;
      const chunk = toFetch.slice(i, i + 6);
      const chunkRes = await Promise.all(chunk.map(async (handle) => {
        if (signal?.aborted || token !== QA.openToken) return null;
        if (cache.has(handle)) return cache.get(handle);
        try {
          const r = await fetch(`/products/${handle}.js`, { headers: { "Accept": "application/json" }, signal });
          if (!r.ok) return null;
          const p = await r.json();
          const sizeIndex = inferSizeIndexFromProductJs(p);
          const variants = Array.isArray(p.variants) ? p.variants.map(v => ({ id: v.id, available: !!v.available, price: v.price, options: normalizeVariantOptionsFromProductJs(v) })) : [];
          const tags = parseTagsAny(p.tags);
          const item = {
            handle, img: p.featured_image || "", title: p.title || "", subtitle: colorFromTitle(p.title),
            variants, sizeIndex, tags, style: styleFromTags(tags), colorKey: normColor(colorFromTitle(p.title)),
            key: `${styleFromTags(tags)}|${normColor(colorFromTitle(p.title))}`,
            productType: p.product_type || p.type || "",
            genderMen: tagsMatchGender(tags, "mens"), genderWomen: tagsMatchGender(tags, "womens"),
            isUnisex: tagsMatchGender(tags, "mens") && tagsMatchGender(tags, "womens")
          };
          upsertItemIntoSexLists(item); cache.set(handle, item); return item;
        } catch (e) { return null; }
      }));
      chunkRes.filter(Boolean).forEach(it => results.push(it));
    }
    if (signal?.aborted || token !== QA.openToken || !results.length) return;
    results.forEach((it) => { if (it?.key && !QA.state.baseKeys.some(x => x.key === it.key)) QA.state.baseKeys.push({ key: it.key, style: it.style, colorKey: it.colorKey, img: it.img || "", subtitle: it.subtitle || "", title: it.title || "", handleWomens: genderedHandleFromHandle(it.handle, "womens"), handleMens: genderedHandleFromHandle(it.handle, "mens") }); });
    const womensAdd = [], mensAdd = [];
    results.forEach((it) => { const sx = sexFromTags(it.tags) || "womens"; if (sx === "mens") mensAdd.push(it); else womensAdd.push(it); });
    QA.state.productsBySex.womens = (QA.state.productsBySex.womens || []).concat(womensAdd);
    QA.state.productsBySex.mens = (QA.state.productsBySex.mens || []).concat(mensAdd);
    ["womens", "mens"].forEach((sx) => { const seen = new Set(); QA.state.productsBySex[sx] = (QA.state.productsBySex[sx] || []).filter((it) => { const h = it?.handle || ""; if (!h || seen.has(h)) return false; seen.add(h); return true; }); });
    renderProductsRow();
    setActiveProductIndex(Math.min(QA.state.activeIndexBySex[QA.state.sex] || 0, Math.max(0, (QA.state.productsBySex[QA.state.sex] || []).length - 1)), true);
  }

  async function hydrateActiveItemIfNeeded() {
    const { parseTagsAny } = GOC;
    const item = getActiveItem();
    if (!item || !item.handle) return;
    if (Array.isArray(item.variants) && item.variants.length && item.variants[0].price != null) return;
    window.__GOC_QA_CACHE__ = window.__GOC_QA_CACHE__ || new Map();
    const cache = window.__GOC_QA_CACHE__;
    if (cache.has(item.handle)) { Object.assign(item, cache.get(item.handle)); return; }
    try {
      const r = await fetch(`/products/${item.handle}.js`, { headers: { "Accept": "application/json" } });
      if (!r.ok) return;
      const p = await r.json();
      const sizeIndex = inferSizeIndexFromProductJs(p);
      const variants = Array.isArray(p.variants) ? p.variants.map(v => ({ id: v.id, available: !!v.available, price: v.price, options: normalizeVariantOptionsFromProductJs(v) })) : [];
      const tags = parseTagsAny(p.tags);
      const merged = { handle: item.handle, img: item.img || p.featured_image || "", title: item.title || p.title || "", subtitle: item.subtitle || colorFromTitle(p.title), variants, sizeIndex, tags, style: item.style || styleFromTags(tags), colorKey: item.colorKey || normColor(colorFromTitle(p.title)), key: item.key || `${item.style || styleFromTags(tags)}|${item.colorKey || normColor(colorFromTitle(p.title))}`, productType: item.productType || p.product_type || p.type || "", isUnisex: tagsMatchGender(tags, "mens") && tagsMatchGender(tags, "womens") };
      cache.set(item.handle, merged); Object.assign(item, merged);
    } catch (e) {}
  }

  // ---- Sex toggle ----
  function getActiveItem() { const list = QA.state.productsBySex[QA.state.sex] || []; return list[QA.state.activeIndexBySex[QA.state.sex] || 0] || null; }
  function detectFootwearFromItem(item, fallbackProductType) {
    // Prefer Shopify product.product_type when set in admin (cleanest signal).
    const explicit = String(
      (item && item.productType) || fallbackProductType || ""
    ).toLowerCase();
    if (explicit) {
      return (
        explicit.indexOf("shoes") !== -1 ||
        explicit.indexOf("slide") !== -1 ||
        explicit.indexOf("sandal") !== -1 ||
        explicit.indexOf("mule") !== -1
      );
    }
    // Fallback: detect footwear by numeric size pattern (5, 5.5, 6, 6.5...).
    // Apparel/socks use letter sizes so they're filtered out automatically.
    if (item && Array.isArray(item.variants) && item.variants.length) {
      const numericSize = /^[0-9]{1,2}(\.[0-9]{1,2})?$/;
      for (let col = 0; col < 3; col++) {
        let hits = 0;
        for (const v of item.variants) {
          const opts = Array.isArray(v.options) ? v.options : [];
          if (numericSize.test(String(opts[col] || "").trim())) hits += 1;
          if (hits >= 2) return true;
        }
      }
    }
    return false;
  }

  function updateSexToggleVisibility() {
    const row = QA.el?.querySelector(".gocqa__sexRow"); if (!row) return;
    // Use the session-cached flag (set once at modal open) instead of
    // re-detecting per item — per-item detection was failing when an item
    // hadn't been hydrated yet, or when product_type came back as something
    // unexpected, causing the toggle to flicker off mid-flow.
    const hide = !QA.state.isFootwearSession;
    row.style.display = hide ? "none" : "";
    row.setAttribute("aria-hidden", hide ? "true" : "false");
    if (hide) { const w = QA.el.querySelector('[data-gocqa-sex="womens"]'); const m = QA.el.querySelector('[data-gocqa-sex="mens"]'); if (w) w.classList.remove("is-active"); if (m) m.classList.remove("is-active"); }
  }

  async function rebuildListForSexFromIndex(sexKey) {
    if (sexKey !== "womens" && sexKey !== "mens") sexKey = "womens";
    // Load the collection index for existence validation, but don't hard-fail if
    // it's unavailable — the explicit per-swatch gender handles are authoritative
    // and don't depend on the style|color matching the index uses.
    const indexOk = await loadSexIndexOnce();
    const prevSex = sexKey === "mens" ? "womens" : "mens";
    const prevItem = (QA.state.productsBySex[prevSex] || [])[QA.state.activeIndexBySex[prevSex] || 0];
    const prevKey = prevItem?.key || null;
    const out = [], seen = new Set();
    (QA.state.baseKeys || []).forEach((bk) => {
      // 1) Explicit gender-pair handle captured from the swatch (or derived from
      //    the item handle). Immune to the style|color key mismatch that broke
      //    products whose swatch subtitle (e.g. "Buzz") differs from the
      //    title-derived color (e.g. "Disney Pixar's Toy Story Buzz Lightyear").
      let handle = (sexKey === "mens" ? bk.handleMens : bk.handleWomens) || "";
      // 2) Legacy fallback: style|color lookup for cards without explicit handles.
      if (!handle && indexOk) { const pair = SEX_INDEX.map.get(bk.key); if (pair) handle = (sexKey === "mens") ? pair.mens : pair.womens; }
      // 3) Validate against the gender-stripped index: prefer the real handle it
      //    knows, and skip items whose opposite sex genuinely doesn't exist (so
      //    the "Not available" fallback still fires for women-only products).
      if (handle && indexOk) {
        const pairR = SEX_INDEX.byRoot.get(handleRoot(handle));
        if (pairR) { const confirmed = (sexKey === "mens") ? pairR.mens : pairR.womens; handle = confirmed || ""; }
      }
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      out.push({ handle, img: bk.img || "", title: bk.title || "", subtitle: bk.subtitle || "", variants: [], sizeIndex: 0, style: bk.style, colorKey: bk.colorKey, key: bk.key });
    });
    if (!out.length) return false;
    QA.state.productsBySex[sexKey] = out;
    let targetIdx = 0; if (prevKey) { const m = out.findIndex(it => it.key === prevKey); if (m >= 0) targetIdx = m; }
    QA.state.activeIndexBySex[sexKey] = targetIdx; return true;
  }

  function clearSexUnavailableNotice() { const note = QA.el?.querySelector("[data-gocqa-sex-notice]"); if (note) note.hidden = true; }

  function showSexUnavailableNotice(sexKey) {
    let note = QA.el?.querySelector("[data-gocqa-sex-notice]");
    if (!note && QA.el) { const row = QA.el.querySelector(".gocqa__sexRow"); if (row) { note = document.createElement("div"); note.className = "gocqa__sexNotice"; note.setAttribute("data-gocqa-sex-notice", ""); row.parentNode.insertBefore(note, row.nextSibling); } }
    if (note) { note.textContent = `Not available for ${sexKey === "mens" ? LABELS.mens : LABELS.womens}`; note.hidden = false; }
  }

  function showSizeLoading() { const track = QA.el?.querySelector("[data-gocqa-size-track]"); if (track) track.innerHTML = `<span class="gocqa__sizeLoading">${LABELS.loading}</span>`; }

  async function setSex(sexKey, initial) {
    if (!sexKey) return; if (sexKey !== "womens" && sexKey !== "mens") sexKey = "womens";
    clearSexUnavailableNotice();
    // Removed the isActiveItemUnisex early-return: double-tagged products
    // (gender_men + gender_women, common for slides) were getting stuck
    // unable to switch sex. The toggle now consistently attempts the swap
    // and falls back to the "Not available" notice if no opposite-sex pair
    // is found in SEX_INDEX.
    QA.state.sex = sexKey;
    const w = QA.el.querySelector('[data-gocqa-sex="womens"]'), m = QA.el.querySelector('[data-gocqa-sex="mens"]');
    if (w) w.classList.toggle("is-active", sexKey === "womens"); if (m) m.classList.toggle("is-active", sexKey === "mens");
    QA.state.selectedVariantId = null; QA.state.selectedPrice = null; updateCTA();
    const token = ++QA.state.sexSwitchToken;
    if (initial) { showSizeLoading(); await hydrateActiveItemIfNeeded(); if (token !== QA.state.sexSwitchToken) return; renderSizesRow(); updateSexToggleVisibility(); return; }
    showSizeLoading();
    const prevSex = sexKey === "mens" ? "womens" : "mens";
    const prevListSnapshot = (QA.state.productsBySex[sexKey] || []).slice();
    const prevIdxSnapshot = QA.state.activeIndexBySex[sexKey] || 0;
    const rebuiltOk = await rebuildListForSexFromIndex(sexKey); if (token !== QA.state.sexSwitchToken) return;
    const list = QA.state.productsBySex[sexKey] || [];
    if (!rebuiltOk || !list.length) {
      QA.state.productsBySex[sexKey] = prevListSnapshot; QA.state.activeIndexBySex[sexKey] = Math.min(prevIdxSnapshot, Math.max(0, prevListSnapshot.length - 1));
      QA.state.sex = prevSex; if (w) w.classList.toggle("is-active", prevSex === "womens"); if (m) m.classList.toggle("is-active", prevSex === "mens");
      showSexUnavailableNotice(sexKey); renderSizesRow(); updateSexToggleVisibility(); return;
    }
    renderProductsRow(); setActiveProductIndex(QA.state.activeIndexBySex[sexKey] || 0, true);
    await hydrateActiveItemIfNeeded(); if (token !== QA.state.sexSwitchToken) return; renderSizesRow(); updateSexToggleVisibility();
  }

  // ---- Rendering ----
  function renderProductsRow() {
    const track = QA.el.querySelector("[data-gocqa-prod-track]"); if (!track) return;
    const list = QA.state.productsBySex[QA.state.sex] || [];
    if (!list.length) { PROD.index = 0; requestAnimationFrame(applyProdTransform); return; }
    PROD.index = Math.max(0, Math.min(list.length - 1, QA.state.activeIndexBySex[QA.state.sex] || 0));
    track.innerHTML = list.map((it, i) => { const img = it?.img || ""; const active = i === PROD.index ? "is-active" : ""; return `<div class="gocqa__prodSlide"><button class="gocqa__prodCard ${active}" type="button" data-gocqa-prod="${i}">${img ? `<img src="${img}" alt="" loading="lazy">` : ""}</button></div>`; }).join("");
    requestAnimationFrame(applyProdTransform);
  }

  function markProdActive() { const { qsa } = GOC; qsa(QA.el, ".gocqa__prodCard").forEach((b) => b.classList.remove("is-active")); const active = QA.el.querySelector(`.gocqa__prodCard[data-gocqa-prod="${PROD.index}"]`); if (active) active.classList.add("is-active"); }

  function applyProdTransform() {
    const { qsa, getCssGapPx } = GOC;
    const track = QA.el.querySelector("[data-gocqa-prod-track]"); if (!track) return;
    const slides = qsa(track, ".gocqa__prodSlide"); if (!slides.length) return;
    const slideW = slides[0].getBoundingClientRect().width; const gap = getCssGapPx(track, 0);
    track.style.transform = `translateX(${-Math.max(0, (PROD.index - 1)) * (slideW + gap)}px)`;
  }

  function onActiveProductChanged() {
    const item = getActiveItem();
    const colorEl = QA.el.querySelector("[data-gocqa-color]");
    if (colorEl) colorEl.textContent = (item?.subtitle || "").trim() || (item?.title || "").trim() || "";
    QA.state.selectedVariantId = null; QA.state.selectedPrice = null; updateCTA();
    const needsHydration = !item || !Array.isArray(item.variants) || !item.variants.length;
    if (needsHydration) showSizeLoading();
    (async () => { await hydrateActiveItemIfNeeded(); renderSizesRow(); updateSexToggleVisibility(); })();
  }

  function nudgeProd(dir) { const list = QA.state.productsBySex[QA.state.sex] || []; if (!list.length) return; PROD.index = Math.max(0, Math.min(list.length - 1, PROD.index + dir)); QA.state.activeIndexBySex[QA.state.sex] = PROD.index; markProdActive(); applyProdTransform(); onActiveProductChanged(); }

  function setActiveProductIndex(i, skipTransform) {
    const list = QA.state.productsBySex[QA.state.sex] || [];
    if (!list.length) { const c = QA.el.querySelector("[data-gocqa-color]"); if (c) c.textContent = ""; QA.state.selectedVariantId = null; QA.state.selectedPrice = null; updateCTA(); renderSizesRow(); return; }
    PROD.index = Math.max(0, Math.min(list.length - 1, Number(i || 0))); QA.state.activeIndexBySex[QA.state.sex] = PROD.index;
    markProdActive(); if (!skipTransform) applyProdTransform(); onActiveProductChanged();
  }

  function resolveSizeIndex(item) {
    // The stored item.sizeIndex can be stale (e.g. 0 by default on items
    // synthesized in rebuildListForSexFromIndex before hydration completes).
    // Sanity-check it against the actual variants — if the column at the stored
    // index doesn't look like a size (numeric pattern, or letter sizes), scan
    // the other columns and pick the one that does.
    const variants = Array.isArray(item?.variants) ? item.variants : [];
    if (!variants.length) return Number(item?.sizeIndex || 0);
    const stored = Number(item?.sizeIndex || 0);
    const numericSize = /^[0-9]{1,2}(\.[0-9]{1,2})?$/;
    const letterSize = /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl)$/i;
    const looksLikeSize = (v) => {
      const s = String(v || "").trim();
      return numericSize.test(s) || letterSize.test(s);
    };
    const columnScore = (col) => {
      let hits = 0;
      for (const v of variants) {
        const opts = Array.isArray(v.options) ? v.options : [];
        if (looksLikeSize(opts[col])) hits += 1;
      }
      return hits;
    };
    if (columnScore(stored) >= 2) return stored;
    let best = stored, bestScore = columnScore(stored);
    for (let col = 0; col < 3; col++) {
      const score = columnScore(col);
      if (score > bestScore) { bestScore = score; best = col; }
    }
    return best;
  }

  function renderSizesRow() {
    const { escapeHtml } = GOC;
    const track = QA.el.querySelector("[data-gocqa-size-track]"); if (!track) return;
    const item = getActiveItem(); const variants = item?.variants || []; const sizeIndex = resolveSizeIndex(item);
    // B2C PREORDER DATE CUTOFF: variants whose pre-order date is too far out are treated as unavailable (see window.GOCBlockedVariants).
    const blockedMap = window.GOCBlockedVariants || {};
    const isBlocked = (v) => !!(v && (v.blocked === true || blockedMap[v.id] || blockedMap[String(v.id)]));
    const map = new Map();
    variants.forEach((v) => { const opts = Array.isArray(v.options) ? v.options : []; const size = opts[sizeIndex]; if (!size) return; if (!map.has(size)) map.set(size, { available: false, id: null, price: null }); const it = map.get(size); if (v.available && !isBlocked(v) && !it.available) { it.available = true; it.id = v.id; it.price = v.price; } });
    track.innerHTML = Array.from(map.keys()).map((sz) => { const it = map.get(sz); const dis = it.available ? "" : " is-disabled"; return `<button class="gocqa__sizeChip${dis}" type="button" data-gocqa-size="${escapeHtml(sz)}" data-gocqa-variant="${it.id || ""}" data-gocqa-price="${it.price || ""}">${escapeHtml(String(sz).replace(".00", ""))}</button>`; }).join("");
    SIZE.idx = 0; track.style.transform = "translateX(0px)";
  }

  function nudgeSize(dir) { const { qsa, getCssGapPx } = GOC; const track = QA.el.querySelector("[data-gocqa-size-track]"); if (!track) return; const chips = qsa(track, ".gocqa__sizeChip"); if (!chips.length) return; const chipW = chips[0].getBoundingClientRect().width; const gap = getCssGapPx(track, 10); const vp = track.parentElement; const vpW = vp ? vp.getBoundingClientRect().width : 0; const totalW = chips.length * chipW + Math.max(0, chips.length - 1) * gap; const maxOffset = Math.max(0, totalW - vpW); SIZE.idx = Math.max(0, Math.min(chips.length - 1, SIZE.idx + dir * 4)); const offset = Math.min(SIZE.idx * (chipW + gap), maxOffset); track.style.transform = `translateX(${-offset}px)`; }

  function currentTrackOffset(track) {
    const t = getComputedStyle(track).transform;
    if (!t || t === "none") return 0;
    try { return -(new DOMMatrixReadOnly(t)).m41; } catch (e) { return 0; }
  }

  function attachSizeDrag(track) {
    const TAP_THRESHOLD = 6;
    const onDown = (e) => {
      if (e.target.closest(".gocqa__sizeNav")) return;
      const chips = track.querySelectorAll(".gocqa__sizeChip");
      if (!chips.length) return;
      const chipW = chips[0].getBoundingClientRect().width;
      const gap = GOC.getCssGapPx(track, 10);
      const vp = track.parentElement;
      const vpW = vp ? vp.getBoundingClientRect().width : 0;
      const totalW = chips.length * chipW + Math.max(0, chips.length - 1) * gap;
      SIZE_DRAG.maxOffset = Math.max(0, totalW - vpW);
      SIZE_DRAG.chipStep = chipW + gap;
      SIZE_DRAG.startOffset = currentTrackOffset(track);
      SIZE_DRAG.startX = e.clientX;
      SIZE_DRAG.moved = 0;
      SIZE_DRAG.active = true;
      SIZE_DRAG.pointerId = e.pointerId;
      SIZE_DRAG.targetChip = e.target.closest(".gocqa__sizeChip") || null;
      track.classList.add("is-dragging");
      track.style.transition = "none";
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
    };
    const onMove = (e) => {
      if (!SIZE_DRAG.active || e.pointerId !== SIZE_DRAG.pointerId) return;
      const delta = e.clientX - SIZE_DRAG.startX;
      if (Math.abs(delta) > SIZE_DRAG.moved) SIZE_DRAG.moved = Math.abs(delta);
      let off = SIZE_DRAG.startOffset - delta;
      if (off < 0) off = 0;
      else if (off > SIZE_DRAG.maxOffset) off = SIZE_DRAG.maxOffset;
      track.style.transform = `translateX(${-off}px)`;
    };
    const onUp = (e) => {
      if (!SIZE_DRAG.active || e.pointerId !== SIZE_DRAG.pointerId) return;
      SIZE_DRAG.active = false;
      track.classList.remove("is-dragging");
      track.style.transition = "";
      try { track.releasePointerCapture(e.pointerId); } catch (_) {}
      const chips = track.querySelectorAll(".gocqa__sizeChip");
      if (!chips.length) { SIZE_DRAG.targetChip = null; return; }
      // Tap (no real drag): pointer capture can swallow the synthetic click on iOS Safari,
      // so select the chip directly here using the target captured on pointerdown.
      if (SIZE_DRAG.moved <= TAP_THRESHOLD && SIZE_DRAG.targetChip) {
        const chip = SIZE_DRAG.targetChip;
        SIZE_DRAG.targetChip = null;
        if (!chip.classList.contains("is-disabled")) {
          selectSize(
            chip.getAttribute("data-gocqa-size"),
            chip.getAttribute("data-gocqa-variant"),
            chip.getAttribute("data-gocqa-price")
          );
        }
        return;
      }
      SIZE_DRAG.targetChip = null;
      const off = currentTrackOffset(track);
      let idx = Math.round(off / SIZE_DRAG.chipStep);
      idx = Math.max(0, Math.min(chips.length - 1, idx));
      SIZE.idx = idx;
      const snapped = Math.min(idx * SIZE_DRAG.chipStep, SIZE_DRAG.maxOffset);
      track.style.transform = `translateX(${-snapped}px)`;
    };
    track.addEventListener("pointerdown", onDown);
    track.addEventListener("pointermove", onMove);
    track.addEventListener("pointerup", onUp);
    track.addEventListener("pointercancel", onUp);
    // Swallow the follow-up synthetic click in BOTH cases:
    // - real drag (moved > threshold): user didn't intend to tap
    // - tap (already handled in pointerup above): prevent double-fire
    track.addEventListener("click", (e) => {
      if (SIZE_DRAG.moved > TAP_THRESHOLD) {
        e.preventDefault(); e.stopPropagation(); SIZE_DRAG.moved = 0;
      }
    }, true);
  }

  function selectSize(sizeValue, variantId, price) {
    const { qsa, cssEscapeAttr } = GOC;
    qsa(QA.el, ".gocqa__sizeChip").forEach((c) => c.classList.remove("is-active"));
    const chip = QA.el.querySelector(`.gocqa__sizeChip[data-gocqa-size="${cssEscapeAttr(sizeValue)}"]`);
    if (chip) chip.classList.add("is-active");
    QA.state.selectedVariantId = variantId ? String(variantId) : null;
    QA.state.selectedPrice = price ? Number(price) : null;
    updateCTA();
  }

  function formatMoney(cents) { if (!cents && cents !== 0) return ""; return "$" + (Number(cents) / 100).toFixed(2).replace(/\.00$/, ""); }

  function updateCTA() {
    const cta = QA.el.querySelector("[data-gocqa-cta]"); if (!cta) return;
    const ready = !!QA.state.selectedVariantId;
    cta.disabled = !ready; cta.classList.toggle("is-ready", ready);
    if (ready && QA.state.selectedPrice) cta.innerHTML = `${LABELS.addToCart}<span class="gocqa__ctaDot">&middot;</span><span class="gocqa__ctaPrice">${formatMoney(QA.state.selectedPrice)}</span>`;
    else cta.textContent = ready ? LABELS.addToCart : LABELS.selectSize;
  }

  async function submitMobileQA() {
    if (!QA.state.selectedVariantId) return;
    const { addToCart, openCartDrawerBestEffort } = GOC;
    const btn = QA.el.querySelector("[data-gocqa-cta]"); if (btn) btn.disabled = true;
    try { await addToCart(QA.state.selectedVariantId, 1); closeMobileQA(); openCartDrawerBestEffort(); }
    catch (e) { if (btn) btn.disabled = false; updateCTA(); }
  }

  // ---- Injection ----
  function injectMobileQuickAddOnce() {
    if (QA.inited && QA.el && document.body.contains(QA.el)) return;
    QA.inited = false; QA.el = null; QA.inited = true;
    const el = document.createElement("div"); el.className = "gocqa"; el.setAttribute("aria-hidden", "true");
    el.innerHTML = `<div class="gocqa__backdrop" data-gocqa-close></div>
      <div class="gocqa__sheet" role="dialog" aria-modal="true">
        <div class="gocqa__head"><h2 class="gocqa__title">${LABELS.quickAdd}</h2><button class="gocqa__close" type="button" aria-label="Close" data-gocqa-close>×</button></div>
        <div class="gocqa__rule"></div>
        <div class="gocqa__body">
          <div class="gocqa__subtitle" data-gocqa-color></div>
          <div class="gocqa__prodRow">
            <button class="gocqa__prodNav gocqa__prodPrev" type="button" data-gocqa-prod-prev><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow"></path></svg></button>
            <button class="gocqa__prodNav gocqa__prodNext" type="button" data-gocqa-prod-next><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow" transform="translate(100,100) rotate(180)"></path></svg></button>
            <div class="gocqa__prodSwiper"><div class="gocqa__prodTrack" data-gocqa-prod-track></div></div>
          </div>
          <div class="gocqa__sexRow" role="tablist" aria-label="Gender">
            <button class="gocqa__sexBtn is-active" type="button" data-gocqa-sex="womens">${LABELS.womens}</button>
            <button class="gocqa__sexBtn" type="button" data-gocqa-sex="mens">${LABELS.mens}</button>
          </div>
          <div class="gocqa__sizeTop"><div class="gocqa__sizeLabel">${LABELS.size}</div><button class="gocqa__infoBtn" type="button" aria-label="Size chart" data-gocqa-sizeinfo>i</button></div>
          <div class="gocqa__sizeRow">
            <button class="gocqa__sizeNav gocqa__sizePrev" type="button" data-gocqa-size-prev><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow"></path></svg></button>
            <button class="gocqa__sizeNav gocqa__sizeNext" type="button" data-gocqa-size-next><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow" transform="translate(100,100) rotate(180)"></path></svg></button>
            <div class="gocqa__sizeViewport"><div class="gocqa__sizeTrack" data-gocqa-size-track></div></div>
          </div>
        </div>
        <div class="gocqa__cta"><button class="gocqa__ctaBtn" type="button" data-gocqa-cta disabled>${LABELS.selectSize}</button></div>
      </div>`;
    document.body.appendChild(el); QA.el = el;

    const sizeTrack = el.querySelector("[data-gocqa-size-track]");
    if (sizeTrack) attachSizeDrag(sizeTrack);

    el.addEventListener("click", (e) => {
      if (e.target.closest("[data-gocqa-close]")) { e.preventDefault(); closeMobileQA(); return; }
      const pbtn = e.target.closest("[data-gocqa-prod]"); if (pbtn) { e.preventDefault(); setActiveProductIndex(Number(pbtn.getAttribute("data-gocqa-prod") || "0")); return; }
      const sbtn = e.target.closest("[data-gocqa-sex]"); if (sbtn) { e.preventDefault(); setSex(sbtn.getAttribute("data-gocqa-sex")); return; }
      const sizeChip = e.target.closest("[data-gocqa-size]"); if (sizeChip) { e.preventDefault(); if (sizeChip.classList.contains("is-disabled")) return; selectSize(sizeChip.getAttribute("data-gocqa-size"), sizeChip.getAttribute("data-gocqa-variant"), sizeChip.getAttribute("data-gocqa-price")); return; }
      if (e.target.closest("[data-gocqa-cta]")) { e.preventDefault(); submitMobileQA(); return; }
      if (e.target.closest("[data-gocqa-sizeinfo]")) { e.preventDefault(); openSizeChart(); return; }
      if (e.target.closest("[data-gocqa-prod-prev]")) { nudgeProd(-1); return; }
      if (e.target.closest("[data-gocqa-prod-next]")) { nudgeProd(1); return; }
      if (e.target.closest("[data-gocqa-size-prev]")) { nudgeSize(-1); return; }
      if (e.target.closest("[data-gocqa-size-next]")) { nudgeSize(1); return; }
    });
    document.addEventListener("keydown", (e) => { if (QA.el?.getAttribute("aria-hidden") === "false" && e.key === "Escape") closeMobileQA(); });
    QA.el.addEventListener("touchmove", (e) => { if (QA.el.getAttribute("aria-hidden") === "false") { if (!e.target.closest(".gocqa__body")) e.preventDefault(); } }, { passive: false });
  }

  function detectInitialSex(card) {
    // Pick the gender that matches the source context. Card's base handle wins
    // (e.g. "ona-classic-mens-black") because it's the most specific signal;
    // the collection URL is a backup for gender landing pages where handle is
    // gender-neutral. \b word boundaries avoid false positives like "garments"
    // matching "men". "womens?" handles both "women" and "womens" spellings.
    const sources = [
      String((card && card.dataset && card.dataset.baseHandle) || ""),
      (typeof window !== "undefined" && window.location ? window.location.pathname : "")
    ];
    for (const src of sources) {
      const s = String(src).toLowerCase();
      if (/\bwomens?\b/.test(s)) return "womens";
      if (/\bmens?\b/.test(s)) return "mens";
    }
    return "womens";
  }

  function setSexToggleActiveButton(sexKey) {
    const w = QA.el?.querySelector('[data-gocqa-sex="womens"]');
    const m = QA.el?.querySelector('[data-gocqa-sex="mens"]');
    if (w) w.classList.toggle("is-active", sexKey === "womens");
    if (m) m.classList.toggle("is-active", sexKey === "mens");
  }

  // ---- Open / Close ----
  async function openMobileQAFromCard(card) {
    if (window.innerWidth >= 990) return;
    const { decodeVariants } = GOC;
    injectMobileQuickAddOnce();
    loadSexIndexOnce().catch(() => {});
    try { QA.aborter?.abort(); } catch (e) {}
    QA.aborter = new AbortController(); QA.openToken += 1; const token = QA.openToken;
    QA.activeCard = card;
    QA.state.selectedVariantId = null; QA.state.selectedPrice = null;
    QA.state.productsBySex.womens = []; QA.state.productsBySex.mens = [];
    QA.state.activeIndexBySex.womens = 0; QA.state.activeIndexBySex.mens = 0;
    QA.state.baseKeys = [];
    QA.state.sex = detectInitialSex(card);
    setSexToggleActiveButton(QA.state.sex);
    clearSexUnavailableNotice();
    QA.el.setAttribute("aria-hidden", "false"); document.documentElement.style.overflow = "hidden"; document.body.classList.add("gocqa-open");

    const domSwatches = Array.from(card.querySelectorAll('.gpcard__swatch[data-sp-handle]'));
    const cardProductType = (card.dataset && card.dataset.productType) || "";
    const domItems = domSwatches.map((btn) => {
      const handle = btn.getAttribute("data-sp-handle") || "";
      const img = btn.getAttribute("data-sp-img1") || "";
      const subtitle = btn.getAttribute("data-sp-subtitle") || btn.getAttribute("data-sp-title") || "";
      const title = btn.getAttribute("data-sp-card-title") || "";
      const variantsEnc = btn.getAttribute("data-sp-variants") || "";
      const sizeIndex = btn.getAttribute("data-sp-size-index") || card.dataset.sizeIndex || "0";
      const style = btn.getAttribute("data-sp-style") || card.dataset.style || LABELS.defaultStyle || "";
      const colorKey = normColor(subtitle || title); const key = `${style}|${colorKey}`;
      const handleWomens = btn.getAttribute("data-sp-handle-womens") || genderedHandleFromHandle(handle, "womens");
      const handleMens = btn.getAttribute("data-sp-handle-mens") || genderedHandleFromHandle(handle, "mens");
      QA.state.baseKeys.push({ key, style, colorKey, img, subtitle, title, handleWomens, handleMens });
      return { handle, img, title, subtitle, variants: decodeVariants(variantsEnc), sizeIndex: Number(sizeIndex || 0), style, colorKey, key, productType: cardProductType, isUnisex: false };
    });
    QA.state.productsBySex.womens = domItems.slice(); QA.state.productsBySex.mens = domItems.slice();
    // Lock in the footwear classification once, using the best signal available
    // from the source card. From here on the sex toggle visibility is fixed for
    // this modal session — color/sex switches can't flip it off mid-flow.
    //
    // Some product cards (notably some men's collection slides) render with no
    // swatch_collection configured, so .gpcard__swatch[data-sp-handle] selectors
    // come back empty and domItems[0] is undefined. The card itself always
    // carries data-base-variants though, so use that as a backup signal.
    const baseVariantsEnc = card.dataset.baseVariants || card.getAttribute("data-base-variants") || "";
    const baseVariants = decodeVariants(baseVariantsEnc);
    const swatchItem = domItems[0] || null;
    const swatchHasVariants = swatchItem && Array.isArray(swatchItem.variants) && swatchItem.variants.length;
    const detectionItem = swatchHasVariants
      ? swatchItem
      : (Array.isArray(baseVariants) && baseVariants.length
          ? { variants: baseVariants, productType: cardProductType }
          : null);
    QA.state.isFootwearSession = detectFootwearFromItem(detectionItem, cardProductType);
    const activeDomIdx = getActiveSwatchIndexInDom(card);
    QA.state.activeIndexBySex.womens = Math.max(0, activeDomIdx); QA.state.activeIndexBySex.mens = Math.max(0, activeDomIdx);
    renderProductsRow(); await setSex(QA.state.sex, true);
    setActiveProductIndex(QA.state.activeIndexBySex[QA.state.sex] || 0, true);
    const moreHandles = parseMoreHandles(card);
    if (moreHandles.length) fetchMoreProductsIntoPopup(moreHandles, token, QA.aborter.signal).catch(() => {});
  }

  function closeMobileQA() {
    if (!QA.el) return;
    try { QA.aborter?.abort(); } catch (e) {} QA.aborter = null;
    QA.el.setAttribute("aria-hidden", "true"); document.documentElement.style.overflow = ""; document.body.classList.remove("gocqa-open");
    QA.activeCard = null; QA.state.selectedVariantId = null; QA.state.selectedPrice = null;
  }

  Object.assign(GOC, { QA, openMobileQAFromCard, closeMobileQA });
})();
